import InternalDocumentIncomingDetail from "./modules/InternalDocumentIncoming/InternalDocumentIncomingDetail";
import { InternalDocumentOutgoingDetail } from "./modules/InternalDocumentOutgoing";
import WorkDetail from "./modules/work/WorkDetail";
import { DocumentPage } from "./pages";
import CompanyWorkSchedulePage from "./pages/CompanyWorkSchedulePage";
import DashBoardPage from "./pages/DashBoardPage";
import LoginPage from "./pages/LoginPage";
import MenuPage from "./pages/MenuPage";
import MissionPage from "./pages/MissionPage";
import ProfilePage from "./pages/ProfilePage";
import UpdateProfile from "./pages/UpdateProfile";
import WorkPage from "./pages/WorkPage";
import TinTucPage from './pages/TinTucPage';
import CompanyWorkScheduleDetail from "./modules/CompanyWorkSchedule/CompanyWorkScheduleDetail";
import MissionDetail from "./modules/mission/MissionDetail";
import TinTucDetail from './modules/tintuc/TinTucDetail';

export const normalRoutes = [
    {
        path: "/login",
        component: <LoginPage />,
        name: "Login",
    },
    // {
    //     path: "/portalv2",
    //     component: PortalPageV2,
    //     name: "Trang chủ",
    // },
];

export const routes = [
    {
        path: "/",
        component: <DashBoardPage />,
        name: "Trang chủ",
    },
    {
        path: "/demo",
        component: <InternalDocumentIncomingDetail />,
        name: "Trang chủ",
    },

    {
        path: "/internal-document/incoming-document/view/:documentId",
        component: <InternalDocumentIncomingDetail />,
        name: "Chi tiết",
    },
    {
        path: "/internal-document/outgoing-document/view/:documentId",
        component: <InternalDocumentOutgoingDetail />,
        name: "Chi tiết",
    },
    {
        path: "/work",
        component: <WorkPage />,
        name: "Công việc",
    },
    {
        path: "/work/view/:workId",
        component: <WorkDetail />,
        name: "Chi tiết công việc",
    },
    {
        path: "/my-profile",
        component: <ProfilePage />,
        name: "Cá nhân",
    },
    {
        path: "/menu",
        component: <MenuPage />,
        name: "Menu",
    },
    {
        path: "/update-profile",
        component: <UpdateProfile />,
        name: "Cập nhật",
    },
    {
        path: "/company-work-schedule",
        component: <CompanyWorkSchedulePage />,
        name: "Cập nhật",
    },
    {
        path: "/company-work-schedule/view/:companyWorkId",
        component: <CompanyWorkScheduleDetail />,
        name: "Cập nhật",
    },
    {
        path: "/utility/general-notifications",
        component: <TinTucPage />,
        name: "Thông báo chung",
    },
    {
        path: "/utility/general-notifications/view/:newsId",
        component: <TinTucDetail />,
        name: "Chi tiết thông báo chung",
    },
    {
        path: "/mission",
        component: <MissionPage />,
        name: "Nhiệm vụ",
    },
    {
        path: "/mission/view/:taskId",
        component: <MissionDetail />,
        name: "Chi tiết Nhiệm vụ",
    },
];
